import { TLCEXTJQuery } from "./jquery";
import { Engine } from "./Engine";

export const TLCEXT = {
	_baseOptions: {
		prefixRegex: "{",
		suffixRegex: "}",
		loopIndexVariableName: "@index",
		loopStartPrefixRegex: "#~",
		loopStartSuffixRegex: "#",
		loopEndRegex: "#/~#",
		loopVarPrefixRegex: "##",
		loopVarSuffixRegex: "##",
		currentVariableName: "@"
	},
	
	library: TLCEXTJQuery,
	
	_baseData: {},
	
	/**
	 *
	 * @param contentToCompile
	 * @param {Object=} passedBaseOptions
	 * @param {Object} passedBaseValues
	 * @return {Engine}
	 * @constructor
	 * @deprecated
	 */
	Template: function (contentToCompile, passedBaseOptions, passedBaseValues) {
	//	if( TLCEXT.library == null ) { throw "No ext library was provided for the template engine."; }
	
		var content = "";
	
		if (Array.isArray(contentToCompile)) {
			for (var _arrayIndex = 0, len = contentToCompile.length; _arrayIndex < len; _arrayIndex += 1) {
				content += contentToCompile[ _arrayIndex ];
			}
		} else {
			content = contentToCompile;
		}
	
		return new Engine(
			TLCEXT.library,
			content,
			( passedBaseOptions !== undefined )
				? TLCEXT.library.extend({}, TLCEXT._baseOptions, passedBaseOptions)
				: TLCEXT.library.extend({}, TLCEXT._baseOptions),
			( passedBaseValues !== undefined )
				? TLCEXT.library.extend({}, TLCEXT._baseData, passedBaseValues)
				: TLCEXT.library.extend({}, TLCEXT._baseData)
		);
	},
	
	/**
	 *
	 * @param {Object} newBaseData
	 * @deprecated
	 */
	setBaseData: function (newBaseData) {
		TLCEXT._baseData = TLCEXT.library.extend({}, TLCEXT._baseData, newBaseData);
	},
	
	/**
	 *
	 * @param {Object} library
	 * @deprecated
	 */
	setLibrary: function (library) {
		TLCEXT.library = library;
	}
	

};
